export const PHONE_REGEX = new RegExp(
    /^(?:0|98|\+98|\+980|0098|098|00980)?(9\d{9})$/
)

/**
 * The `+989xxxxxxxxx` form the backend stores, from anything PHONE_REGEX
 * accepts.
 *
 * Callers used to send `'+98' + phone.slice(1)`, which is only right for the
 * `09…` spelling. PHONE_REGEX also lets `912…`, `98912…`, `+98912…` and
 * `0098912…` through validation, and those came out as `+9812…`, `+988912…`
 * and so on: the backend either refused the number (a 400 the add-member
 * screen showed as «مشکلی پیش آمده!») or filed the member under a phone
 * nobody owns.
 *
 * Anything PHONE_REGEX does not accept is left to the old rule, so a number
 * the form never validated reaches the backend exactly as it did before.
 */
export const toInternationalPhone = (phone: string): string => {
    const match = (phone || '').trim().match(PHONE_REGEX)
    if (match) {
        return '+98' + match[1]
    }
    return '+98' + (phone || '').slice(1)
}
